document.addEventListener("DOMContentLoaded", () => {

    const heroSections = document.querySelectorAll('[id^="shopify-section"]');
    console.log("ParasHeroTesting", heroSections);
  
    if (heroSections.length > 1) {
  
      const targetSection = heroSections[1];
      console.log("ParasTWWOOO", targetSection);
  
      const contentWrapper = targetSection.querySelector('.hero__content-wrapper');
      console.log("ParasContentWrapper", contentWrapper);
  
      if (!contentWrapper) return;
  
      const buttons = contentWrapper.querySelectorAll('a.button, a.button-secondary');
      console.log("ParasButtons", buttons);
  
      if (buttons.length >= 2) {
  
        const firstButton = buttons[0];
        const lastButton = buttons[buttons.length - 1];
  
        firstButton.classList.add("btn-first");
        lastButton.classList.add("btn-last");
      }
    }
  
  });
  

// document.addEventListener("DOMContentLoaded", () => {

//     const heroSections = document.querySelectorAll('[id^="shopify-section"]');
//     console.log("ParasHeroTesting",heroSections);
//     if (heroSections.length > 1) {
//         const targetSection = heroSections[1];
//         console.log("ParasTWWOOO",targetSection);
//         const contentWrapper = targetSection.querySelector('.hero__content-wrapper');
//         console.log("ParasContentWrapper",contentWrapper);
//         const buttons =contentWrapper.querySelectorAll('a.button, a.button-secondary');
//         if (buttons.length >= 2) {
//             contentWrapper.classList.add('buttonsHome-row-active');
//             console.log("ParasButtons",buttons);
//           }
          
        
//       }
      

    // heroSections.forEach(section => {
  
    //   const rowButtons = section.querySelectorAll('.button--row-enabled');
  
    //   if (rowButtons.length > 0) {
  
    //     const style = document.createElement("style");
  
    //     style.innerHTML = `
    //       #${section.id} .hero__content-wrapper {
    //         --flex-direction: row;
    //         --gap: 12px;
    //       }
  
    //       @media (max-width: 749px) {
    //         #${section.id} .hero__content-wrapper {
    //           --flex-direction: column;
    //         }
    //       }
    //     `;
  
    //     document.head.appendChild(style);
    //   }
    // });
  
//   });
  